import { Box, Grid, Typography, styled } from "@mui/material";
import calendarIcon from "../img/calendar.png";
import callIcon from "../img/call.png";
import locationIcon from "../img/location.png";

const Typo = styled(Typography)(({ theme }) => ({
  textDecoration: "none",
  maxWidth: "max-content",
  "&:hover": {
    transition: "all .2s ease-in-out",
    transform: "scale(1.05)",
    transformOrigin: "center center",
  },
}));
const Gridd = styled(Grid)(({ theme }) => ({
  textDecoration: "none",
  "&:hover": {
    transition: "all .2s ease-in-out",
    transform: "scale(1.05)",
    transformOrigin: "center center",
  },
}));
function Contact() {
  return (
    <Grid
      container
      justifyContent="center"
      sx={{ marginTop: { xs: "-50px", md: "-150px" } }}
    >
      <Box
        sx={{
          padding: "20px",
          width: "350px",
          height: "300px",
          backgroundColor: "#28686c",
        }}
      >
        <img
          src={callIcon}
          alt="call us"
          width="40px"
          style={{
            filter: "invert(100%)",
          }}
        />
        <Box
          sx={{
            margin: "10px 0px",
            borderTop: "1px solid rgb(255,255,255, 0.3)",
          }}
        ></Box>
        <Typography
          sx={{ marginBottom: "10px", fontWeight: "bold" }}
          variant="h6"
          color="text.white"
        >
          Contact us
        </Typography>
        <Typography sx={{ marginBottom: "30px" }} color="text.white">
          Call us by phone during our regular business hours
        </Typography>

        <Gridd
          container
          justifyContent="space-between"
          sx={{ width: "max-content" }}
        >
          <a
            style={{
              color: "white",
              textDecoration: "none",
              width: "max-content",
            }}
            href="tel:519-979-7227"
          >
            <Typography>Phone: 519-979-7227</Typography>
          </a>
        </Gridd>
      </Box>
      <Box
        sx={{
          padding: "20px",
          width: "350px",
          height: "300px",
          backgroundColor: "#3A959B",
        }}
      >
        <img
          src={locationIcon}
          alt="call us"
          width="40px"
          style={{
            filter: "invert(100%)",
          }}
        />
        <Box
          sx={{
            margin: "10px 0px",
            borderTop: "1px solid rgb(255,255,255, 0.3)",
          }}
        ></Box>
        <Typography
          sx={{ marginBottom: "10px", fontWeight: "bold" }}
          color="text.white"
          variant="h6"
        >
          Our Location
        </Typography>

        <a style={{ color: "white", textDecoration: "none" }} href="#contact">
          <Typo
            sx={{
              display: "inline-flex",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            <Typography
              sx={{
                marginTop: "2px",
                display: "inline-flex",
              }}
            >
              1825 Manning Rd | Studio 700 Tecumseh | ON | N9K 0A9
            </Typography>
          </Typo>
        </a>
      </Box>
      <Box
        sx={{
          padding: "20px",
          width: "350px",
          height: "300px",
          backgroundColor: "#deeded",
        }}
      >
        <img src={calendarIcon} alt="call us" width="40px" />
        <Box
          sx={{
            margin: "10px 0px",
            borderTop: "1px solid rgb(0,0,0, 0.3)",
          }}
        ></Box>
        <Typography
          sx={{ marginBottom: "10px", fontWeight: "bold" }}
          variant="h6"
        >
          Hours of Operation
        </Typography>

        <a
          style={{
            textDecoration: "none",
          }}
          href="#contact"
        >
          <Typo
            sx={{
              display: "inline-flex",
              fontWeight: "bold",
              color: "text.primary",
              marginBottom: "10px",
            }}
          >
            <Typography
              sx={{
                marginTop: "2px",
                display: "inline-flex",
              }}
            >
              Mon to Thurs • 8am - 5pm <br /> <br /> Fri • 8am - 3pm
            </Typography>
          </Typo>
        </a>
      </Box>
    </Grid>
  );
}

export default Contact;
